import { useState, useEffect } from 'react';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { useAuth } from '../firebase/useAuth';

function randomShareId() {
  return Math.random().toString(36).slice(2, 8).toUpperCase();
}

export function useFriendLink() {
  const { user } = useAuth();
  const [shareId, setShareId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    setLoading(true);

    const profileRef = doc(db, 'users', user.uid, 'profile', 'main');

    getDoc(profileRef).then(async (snap) => {
      if (snap.exists() && snap.data().shareId) {
        setShareId(snap.data().shareId);
        setLoading(false);
        return;
      }

      const newShareId = randomShareId();
      const shareRef = doc(db, 'shares', newShareId);

      await setDoc(shareRef, {
        ownerId: user.uid,
        ownerName: user.displayName || snap.data()?.displayName || 'Someone',
        createdAt: serverTimestamp(),
      });

      await setDoc(profileRef, { shareId: newShareId }, { merge: true });
      setShareId(newShareId);
      setLoading(false);
    }).catch(err => {
      console.warn('useFriendLink error:', err);
      setLoading(false);
    });
  }, [user]);

  const shareUrl = shareId
    ? `https://creativity.butnoonegothurt.com/join/${shareId}`
    : null;

  return { shareId, shareUrl, loading };
}
